import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["display", "color"];
/* LIBRARIES */
import * as React from 'react';
import { wrapDisplayName } from '@cian/react-utils';
import classNames from 'classnames';

/* STYLES */
import * as styles from './styles/common.css';
import * as colorsStyles from '../../colors/colors.css';
import * as displayStyles from '../../internal/styles/display.css';

/* TYPES */

import { colorsClassesMap } from '../../colors';
export var createIcon = function createIcon(IconComponent) {
  var Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var _props$display = props.display,
      display = _props$display === void 0 ? 'inline-block' : _props$display,
      _props$color = props.color,
      color = _props$color === void 0 ? 'gray_icons_100' : _props$color,
      svgProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement(IconComponent, _extends({}, svgProps, {
      ref: ref,
      className: classNames(styles['container'], displayStyles["display_".concat(display)], colorsStyles[colorsClassesMap[color]]),
      "aria-hidden": "true"
    }));
  });
  Icon.displayName = wrapDisplayName(IconComponent, 'Icon');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon.SVG = IconComponent;
  return Icon;
};